import React, { useState, useEffect } from "react";
import moment from "moment";
import "./Dashboard.scss";
// Mui
import Grid from "@mui/material/Grid";
// React Calendar
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker, createStaticRanges } from "react-date-range";
import { addDays, endOfDay, startOfDay } from "date-fns";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import language from "../../../language";
import { useSelector, useDispatch } from "react-redux";
import {
  searchBuses,
  requestInfo,
  updateDepartureDate,
  updateTripType,
  updateDates,
} from "../../../actions/buses";

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];
const CalendarComponent = ({
  departureDate,
  setDepartureDate,
  returnDate,
  setReturnDate,
  tripType,
  setTripType,
  isPackage,
  onClose,
  requestInfor,
  noOption,
  setRequestInfor,
}) => {
  type ValuePiece = Date | null;
  type Value = ValuePiece | [ValuePiece, ValuePiece];

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
    },
  ]);
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.buses?.requesInfo);
  const [calendarType, setCalendarType] = useState("One Way");
  let languageSelectedEnglish =
    sessionStorage.getItem("language") === "english" ||
    !sessionStorage.getItem("language")
      ? true
      : false;

  const [value, onChange] = useState(new Date());

  useEffect(() => {
    setCalendarType(data?.tripType);
  }, [data]);

  const handleCalenderType = (type) => {
    setCalendarType(type);
    setTripType(type);
    dispatch(updateTripType(type));
    setDepartureDate(moment().format("DD MMM YY"));
    setReturnDate(moment().format("DD MMM YY"));
  };

  const handleCalendarChange = (item) => {
    const formattedDate = moment(item).format("DD MMM YY");
    setDepartureDate(formattedDate);
    setRequestInfor((prev) => ({
      ...prev,
      departureDate: formattedDate,
    }));
  };

  const handleDateRangeChange = (item) => {
    setState([item.range1]);

    const formattedDepartureDate = moment(item.range1.startDate).format(
      "DD MMM YY"
    );
    const formattedReturnDate = moment(item.range1.endDate).format("DD MMM YY");

    setRequestInfor((prev) => ({
      ...prev,
      departureDate: formattedDepartureDate,
      returnDate: formattedReturnDate,
    }));

    setDepartureDate(formattedDepartureDate);
    setReturnDate(formattedReturnDate);

    // dispatch(updateDates(formattedDepartureDate, formattedReturnDate));
  };

  const handleOkClick = () => {
    if (onClose) onClose();
  };

  return (
    <div className="width-wrap1">
      <Grid container className="calendar-wrapper">
        <Grid item xs={12} align="left" className="">
          <h3 className="title-passenger">
            {languageSelectedEnglish
              ? "Choose Departure Date"
              : language.departureDate}
          </h3>
          {noOption && (
            <Grid
              item
              xs={12}
              align="center"
              display="flex"
              justifyContent="center"
            >
              <div
                className={`white-oval cursor-pointer ${
                  tripType == "One Way" ? "selected-trip" : ""
                }`}
                onClick={() => handleCalenderType("One Way")}
              >
                One Way
              </div>
              <div
                className={`white-oval cursor-pointer ${
                  tripType == "Round Trip" ? "selected-trip" : ""
                }`}
                onClick={() => handleCalenderType("Round Trip")}
              >
                Round Trip
              </div>
            </Grid>
          )}
          <Grid item xs={12}>
            {requestInfor.tripType == "Round Trip" && !isPackage ? (
              <DateRangePicker
                onChange={handleDateRangeChange}
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                showDateDisplay={false}
                setState
                months={2}
                color="f6be00"
                // date={addDays(new Date(), -20)}
                ranges={state}
                direction="horizontal"
                minDate={new Date()}
                staticRanges={createStaticRanges([
                  {
                    label: "Today",
                    range: () => ({
                      startDate: startOfDay(new Date()),
                      endDate: endOfDay(new Date()),
                    }),
                  },
                  {
                    label: "Yesterday",
                    range: () => ({
                      startDate: startOfDay(addDays(new Date(), -1)),
                      endDate: endOfDay(addDays(new Date(), -1)),
                    }),
                  },
                  {
                    label: "Last 7 Days",
                    range: () => ({
                      startDate: startOfDay(addDays(new Date(), -7)),
                      endDate: endOfDay(new Date()),
                    }),
                  },
                  {
                    label: "Last 30 Days",
                    range: () => ({
                      startDate: startOfDay(addDays(new Date(), -30)),
                      endDate: endOfDay(new Date()),
                    }),
                  },
                ])}
                inputRanges={[]}
              />
            ) : (
              <Calendar
                onChange={handleCalendarChange}
                className="calenderHome"
                minDate={new Date()}
                value={moment(departureDate, "DD MMM YY").toDate()}
              />
            )}
          </Grid>
          <div className="ok-btn-home-Outer">
            <button
              type="submit"
              className="btn-passenger"
              onClick={handleOkClick}
            >
              OK
            </button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default CalendarComponent;
